module.exports = "/_next/static/images/c5bfb63984c34447786d19ddee17d57d-payment_final.png";